export default String.raw`
<g id="Title + breadcrumbs" fill="none"  >
<rect width="1440" height="125" class="bgColor"/>
<g id="Breadcrumbs">
<foreignObject x="130" y="32" width="900" height="24">
<div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; gap: 8px; font-family: Inter; font-size: 14px; letter-spacing: 0px; align-items: center;">
<span class="primaryColorFont">TRANSLATION_Prv_FilterPanel_Breadcrumb_Home</span>
<span class="primaryColorFont">/</span>
<span class="primaryColorFont">TRANSLATION_Prv_FilterPanel_Breadcrumb_Computers</span>
<span class="primaryColorFont">/</span>
<span class="primaryColorFont">TRANSLATION_Prv_FilterPanel_Breadcrumb_DesktopComputers</span>
<span class="primaryColorFont">/</span>
<span class="primaryColorFont">TRANSLATION_Prv_FilterPanel_Breadcrumb_ComputerComponents</span>
<span class="primaryColorFont">/</span>
<span class="primaryColorFont">TRANSLATION_Prv_FilterPanel_Breadcrumb_Processors</span>
</div>
</foreignObject>
</g>
<g id="Frame 717">
<foreignObject x="130" y="76" width="600" height="32">
<div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; gap: 8px; font-family: Inter; letter-spacing: 0px; align-items: baseline;">
<span class="primaryColorFont" style="font-size: 24px; font-weight: 500;">TRANSLATION_Prv_FilterPanel_Breadcrumb_Processors</span>
<span class="secondaryColorFont" style="font-size: 16px;">TRANSLATION_Prv_FilterPanel_ResultsCount</span>
</div>
</foreignObject>
</g>
</g>
`;